import { ReactNode } from 'react'
import { DevReport202412 } from './202412'
import { DevReport202501 } from './202501'

type DevReportRoute = {
  path: string
  element: ReactNode
}
export const devReportRoutes: DevReportRoute[] = [
  { path: '/release/dev-202412', element: <DevReport202412 /> },
  { path: '/release/dev-202501', element: <DevReport202501 /> },
]
